export const PROGRAM_STRUCTURE_5_CONSTANTS = {
  PROGRAM_STRUCTURE_5_FIELDS_CONFIG: [
    {
      fieldName: "section_background_image",
      label: "Section background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload full-bleed background",
      required: false,
      defaultValue: "",
      filterCategory: "images",
    },
    {
      fieldName: "section_background_image_alt",
      label: "Background image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "section_overlay_rgba",
      label: "Image overlay (RGBA, optional)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty for no overlay, or e.g. rgba(0,0,0,0.45)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "section_background_color",
      label: "Fallback background (when no image)",
      value: "#0B0F14",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#0B0F14",
    },
    {
      fieldName: "headline_primary",
      label: "Headline (wrap highlighted words in { })",
      value: "Skills You'll {Master}",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder:
        "Wrap highlighted words in { } — e.g. Skills You'll {Master}",
      required: false,
      defaultValue: "Skills You'll {Master}",
      rows: 2,
    },
    {
      fieldName: "headline_primary_color",
      label: "Text color (headline base, description & cards)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "headline_accent_color",
      label: "Headline highlight color ({ } words)",
      value: "#F5C542",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F5C542",
    },
    {
      fieldName: "section_description",
      label: "Description (shown under the headline)",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Short paragraph describing the skills section",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_TITLES: {
    metadata: "Skill cards",
  },

  METADATA_FIELDS: [
    {
      header: "Card icon / image",
      fieldName: "card_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Icon shown above the card title",
      required: false,
      filterCategory: "images",
    },
    {
      header: "Card image alt text",
      fieldName: "card_image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the icon",
      required: false,
    },
    {
      header: "Card title",
      fieldName: "card_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Data Structures & Algorithms",
      required: false,
    },
    {
      header: "Card description",
      fieldName: "card_description",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Short supporting text for this card",
      required: false,
    },
    {
      header: "Sort order",
      fieldName: "priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "0",
      required: false,
      defaultValue: 0,
    },
    {
      header: "Active",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: true,
    },
  ],

  DEFAULT_ROW: {
    card_image: "",
    card_image_alt: "",
    card_title: "",
    card_description: "",
    priority: 0,
    status: true,
  },
};
